// @ts-nocheck
/* eslint-disable */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  Button,
  Form,
  Input,
  Message,
  Modal,
  Popconfirm,
  Space,
  Switch,
  Table,
  TableColumnProps,
  Radio,
  Tree,
  Checkbox
} from '@arco-design/web-react';
import { post, get } from '../requestNew';
import { baseUrl } from '../utils';
import dayjs from 'dayjs';

import './index.scss';

const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;

interface UmsRole {
  id?: number;
  name: string;
  description?: string;
  adminCount?: number;
  createTime?: string;
  status: number;
  sort?: number;
}

interface MenuNode {
  id: number;
  title: string;
  children?: MenuNode[];
  [key: string]: any;
}

interface ResourceCategory {
  id: number;
  name: string;
  sort?: number;
}

interface Resource {
  id: number;
  name: string;
  url: string;
  description?: string;
  categoryId: number;
}

function RoleManagement() {
  const [form] = Form.useForm<UmsRole>();
  const [formSearch] = Form.useForm();
  const [menuForm] = Form.useForm();
  const [resourceForm] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [menuModalVisible, setMenuModalVisible] = useState(false);
  const [resourceModalVisible, setResourceModalVisible] = useState(false);
  const [pageSize, setPageSize] = useState(5);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataList, setDataList] = useState<UmsRole[]>([]);
  const [loading, setLoading] = useState(false);
  const [menuTree, setMenuTree] = useState<MenuNode[]>([]);
  const [resourceCategories, setResourceCategories] = useState<ResourceCategory[]>([]);
  const [resourcesByCategory, setResourcesByCategory] = useState<Record<number, Resource[]>>({});
  const [currentRoleId, setCurrentRoleId] = useState<number | null>(null);
  const [checkedMenuKeys, setCheckedMenuKeys] = useState<string[]>([]);
  const formRef = useRef<any>({});

  // 获取数据列表
  const getList = (reset?: boolean) => {
    setLoading(true);
    if (reset) {
      setPageNum(1);
      setPageSize(5);
    }

    const searchValues = formSearch.getFieldsValue();
    const params = {
      keyword: searchValues.keyword || '',
      pageNum: reset ? 1 : pageNum,
      pageSize: reset ? 5 : pageSize
    };

    get('/role/list', params)
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const { list, total: totalCount } = data || {};
          setTotal(totalCount || 0);
          setDataList(list || []);
        } else {
          Message.error(message || '获取数据失败!');
        }
      })
      .catch(() => {
        Message.error('获取数据失败!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 获取菜单树
  const getMenuTree = () => {
    get('/menu/treeList')
      .then((res: any) => {
        const { code, data } = res || {};
        if (code === 200) {
          setMenuTree(data || []);
        }
      })
      .catch(() => {
        Message.error('获取菜单树失败!');
      });
  };

  // 获取角色菜单
  const getRoleMenus = (roleId: number) => {
    get(`/role/listMenu/${roleId}`)
      .then((res: any) => {
        const { code, data } = res || {};
        if (code === 200) {
          const menuIds = (data || []).map((menu: any) => menu.id);
          menuForm.setFieldsValue({ menuIds });
          // 同步更新 checkedKeys state（转换为字符串）
          setCheckedMenuKeys(menuIds.map(String));
        }
      })
      .catch(() => {
        Message.error('获取角色菜单失败!');
      });
  };

  // 获取资源分类和资源
  const getResourceData = async () => {
    try {
      // 获取所有资源分类
      const categoryRes = await get('/resourceCategory/listAll');
      if (categoryRes.code === 200) {
        const categories = categoryRes.data || [];
        setResourceCategories(categories);

        // 获取所有资源
        const resourceRes = await get('/resource/listAll');
        if (resourceRes.code === 200) {
          const resources = resourceRes.data || [];
          // 按分类分组
          const grouped: Record<number, Resource[]> = {};
          categories.forEach((cat: ResourceCategory) => {
            grouped[cat.id] = resources.filter((r: Resource) => r.categoryId === cat.id);
          });
          setResourcesByCategory(grouped);
        }
      }
    } catch (error) {
      Message.error('获取资源数据失败!');
    }
  };

  // 获取角色资源
  const getRoleResources = (roleId: number) => {
    get(`/role/listResource/${roleId}`)
      .then((res: any) => {
        const { code, data } = res || {};
        if (code === 200) {
          const resourceIds = (data || []).map((resource: any) => resource.id);
          resourceForm.setFieldsValue({ resourceIds });
        }
      })
      .catch(() => {
        Message.error('获取角色资源失败!');
      });
  };

  // 表格列配置
  const columns: TableColumnProps[] = [
    {
      title: '编号',
      dataIndex: 'id',
      width: 80
    },
    {
      title: '角色名称',
      dataIndex: 'name',
      width: 150
    },
    {
      title: '描述',
      dataIndex: 'description',
      width: 200
    },
    {
      title: '用户数',
      dataIndex: 'adminCount',
      width: 100,
      render: (text) => text || 0
    },
    {
      title: '添加时间',
      dataIndex: 'createTime',
      width: 180,
      render: (text) => text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
    {
      title: '是否启用',
      dataIndex: 'status',
      width: 100,
      render: (text, record) => (
        <Switch 
          checked={text === 1} 
          onChange={val => handleStatusChange(val, record)} 
        />
      )
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 300,
      render: (_, record: UmsRole) => (
        <Space>
          <Button 
            type="text" 
            onClick={() => handleAssignMenu(record)} 
            loading={loading}
          >
            分配菜单
          </Button>
          <Button 
            type="text" 
            onClick={() => handleAssignResource(record)} 
            loading={loading}
          >
            分配资源
          </Button>
          <Button 
            type="text" 
            onClick={() => edit(record)} 
            loading={loading}
          >
            编辑
          </Button>
          <Popconfirm 
            focusLock 
            title="提示" 
            content="是否要删除该角色?" 
            onOk={() => del(record)}
          >
            <Button 
              type="text" 
              status="danger" 
              loading={loading}
            >
              删除
            </Button>
          </Popconfirm>
        </Space>
      )
    }
  ];

  // 处理状态变更
  const handleStatusChange = (val: boolean, record: UmsRole) => {
    if (!record.id) {
      Message.error('角色ID不存在！');
      return;
    }
    setLoading(true);
    const status = val ? 1 : 0;
    get(`/role/updateStatus/${record.id}`, { status })
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('操作成功！');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 重置筛选条件
  const handleReset = () => {
    formSearch.resetFields();
    setPageNum(1);
    setPageSize(5);
    getList(true);
  };

  // 新增角色
  const add = () => {
    formRef.current = {};
    form.resetFields();
    form.setFieldsValue({
      status: 1,
      sort: 0
    });
    setVisible(true);
  };

  // 删除角色
  const del = (record: UmsRole) => {
    if (!record.id) {
      Message.error('角色ID不存在！');
      return;
    }
    setLoading(true);

    // cursor todo: 后端接口使用@RequestParam接收List，需要确认参数传递方式
    const queryParams = new URLSearchParams();
    queryParams.append('ids', String(record.id));
    
    get(`/role/delete?${queryParams.toString()}`)
      .then((res: any) => {
        const { code, message } = res.data || {};
        if (code === 200) {
          Message.success('删除成功！');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 编辑角色
  const edit = (record: UmsRole) => {
    formRef.current = record;
    form.setFieldsValue(record);
    setVisible(true);
  };

  // 分配菜单
  const handleAssignMenu = (record: UmsRole) => {
    if (!record.id) {
      Message.error('角色ID不存在！');
      return;
    }
    setCurrentRoleId(record.id);
    getMenuTree();
    getRoleMenus(record.id);
    setMenuModalVisible(true);
  };

  // 分配资源
  const handleAssignResource = (record: UmsRole) => {
    if (!record.id) {
      Message.error('角色ID不存在！');
      return;
    }
    setCurrentRoleId(record.id);
    getResourceData();
    getRoleResources(record.id);
    setResourceModalVisible(true);
  };

  // 取消编辑
  const editCancel = () => {
    formRef.current = {};
    setVisible(false);
    form.resetFields();
  };

  // 取消分配菜单
  const menuModalCancel = () => {
    setMenuModalVisible(false);
    setCurrentRoleId(null);
    menuForm.resetFields();
    setCheckedMenuKeys([]);
  };

  // 取消分配资源
  const resourceModalCancel = () => {
    setResourceModalVisible(false);
    setCurrentRoleId(null);
    resourceForm.resetFields();
  };

  // 提交表单
  const onOk = () => {
    form.validate().then(values => {
      setLoading(true);
      const data = {
        ...formRef.current,
        ...values
      };

      if (formRef.current.id) {
        // 更新角色
        post(`/role/update/${formRef.current.id}`, data)
          .then((res: any) => {
            const { code, message } = res || {};
            if (code === 200) {
              Message.success('编辑成功！');
              getList();
              editCancel();
            } else {
              Message.error(message);
            }
          })
          .catch(e => {
            Message.error('网络错误!');
            console.log(e);
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        // 创建角色
        post(`/role/create`, data)
          .then((res: any) => {
            const { code, message } = res || {};
            if (code === 200) {
              Message.success('新增成功！');
              getList();
              editCancel();
            } else {
              Message.error(message);
            }
          })
          .catch(e => {
            Message.error('网络错误!');
            console.log(e);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }).catch(() => {
      Message.error('请检查表单填写是否正确!');
    });
  };

  // 提交菜单分配
  const onMenuOk = () => {
    menuForm.validate().then(values => {
      if (!currentRoleId) {
        Message.error('角色ID不存在！');
        return;
      }
      setLoading(true);
      const { menuIds } = values;
      
      post(`/role/allocMenu`, {
        roleId: currentRoleId,
        menuIds: menuIds || []
      })
        .then((res: any) => {
          const { code, message } = res || {};
          if (code === 200) {
            Message.success('分配菜单成功！');
            menuModalCancel();
            getList();
          } else {
            Message.error(message);
          }
        })
        .catch((e: any) => {
          Message.error('网络错误!');
          console.log(e);
        })
        .finally(() => {
          setLoading(false);
        });
    }).catch(() => {
      Message.error('请检查表单填写是否正确!');
    });
  };

  // 提交资源分配
  const onResourceOk = () => {
    resourceForm.validate().then(values => {
      if (!currentRoleId) {
        Message.error('角色ID不存在！');
        return;
      }
      setLoading(true);
      const { resourceIds } = values;
      
      post(`/role/allocResource`, {
        roleId: currentRoleId,
        resourceIds: resourceIds || []
      })
        .then((res: any) => {
          const { code, message } = res || {};
          if (code === 200) {
            Message.success('分配资源成功！');
            resourceModalCancel();
            getList();
          } else {
            Message.error(message);
          }
        })
        .catch((e: any) => {
          Message.error('网络错误!');
          console.log(e);
        })
        .finally(() => {
          setLoading(false);
        });
    }).catch(() => {
      Message.error('请检查表单填写是否正确!');
    });
  };

  // 递归收集所有选中的菜单ID
  const collectMenuIds = (nodes: MenuNode[], selectedKeys: number[]): number[] => {
    let ids: number[] = [];
    nodes.forEach(node => {
      if (selectedKeys.includes(node.id)) {
        ids.push(node.id);
      }
      if (node.children && node.children.length > 0) {
        ids = ids.concat(collectMenuIds(node.children, selectedKeys));
      }
    });
    return ids;
  };

  // 递归收集所有菜单节点的 key（字符串格式）
  const collectAllMenuKeys = (nodes: MenuNode[]): string[] => {
    let keys: string[] = [];
    nodes.forEach(node => {
      keys.push(String(node.id));
      if (node.children && node.children.length > 0) {
        keys = keys.concat(collectAllMenuKeys(node.children));
      }
    });
    return keys;
  };

  // 获取所有菜单节点的 key
  const allMenuKeys = useMemo(() => collectAllMenuKeys(menuTree), [menuTree]);

  // 判断是否全选
  const isAllSelected = useMemo(() => {
    return allMenuKeys.length > 0 && allMenuKeys.every(key => checkedMenuKeys.includes(key));
  }, [allMenuKeys, checkedMenuKeys]);

  // 全选/全取消处理
  const handleSelectAll = () => {
    if (isAllSelected) {
      // 全取消
      setCheckedMenuKeys([]);
      menuForm.setFieldValue('menuIds', []);
    } else {
      // 全选
      setCheckedMenuKeys(allMenuKeys);
      // const checkedIds = allMenuKeys.map(String);
      const checkedIds = allMenuKeys.map(Number);
      menuForm.setFieldValue('menuIds', checkedIds);
    }
  };

  useEffect(() => {
    getList();
  }, [pageNum, pageSize]);

  // 同步表单值和 checkedKeys state
  useEffect(() => {
    const menuIds = menuForm.getFieldValue('menuIds') || [];
    setCheckedMenuKeys(menuIds.map(String));
  }, [menuModalVisible]);

  return (
    <div className="role-management table-flex">
      <div className="filter-section">
        <Form style={{ width: '100%' }} autoComplete="off" layout="inline" form={formSearch}>
          <FormItem label="输入搜索:" field="keyword">
            <Input style={{ width: 200 }} placeholder="角色名称" allowClear />
          </FormItem>
          <FormItem>
            <Button type="outline" onClick={handleReset} loading={loading}>
              重置
            </Button>
          </FormItem>
          <FormItem>
            <Button type="primary" onClick={() => getList(true)} loading={loading}>
              查询
            </Button>
          </FormItem>
          <Button type="primary" onClick={add} loading={loading}>
            添加
          </Button>
        </Form>
      </div>
      <Table
        rowKey="id"
        columns={columns}
        data={dataList}
        className="table-scroll"
        pagination={{
          sizeCanChange: true,
          pageSize,
          total,
          showTotal: true,
          current: pageNum,
          onChange: (num, size) => {
            setPageNum(num);
            if (size && size !== pageSize) {
              setPageSize(size);
            }
          }
        }}
        scroll={{ y: '100%', x: '100%' }}
        loading={loading}
      />

      {/* 新增/编辑角色弹框 */}
      <Modal
        title={formRef.current.id ? '编辑角色' : '添加角色'}
        visible={visible}
        onCancel={editCancel}
        onOk={onOk}
        unmountOnExit
        style={{ width: 600 }}
        confirmLoading={loading}
      >
        <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
          <FormItem label="角色名称:" field="name" rules={[{ required: true, message: '请输入角色名称' }]}>
            <Input placeholder="请输入..." />
          </FormItem>
          <FormItem label="描述:" field="description">
            <Input.TextArea placeholder="请输入..." rows={3} />
          </FormItem>
          <FormItem label="是否启用:" field="status" triggerPropName="value">
            <Radio.Group>
              <Radio value={1}>是</Radio>
              <Radio value={0}>否</Radio>
            </Radio.Group>
          </FormItem>
        </Form>
      </Modal>

      {/* 分配菜单弹框 */}
      <Modal
        title="分配菜单"
        visible={menuModalVisible}
        onCancel={menuModalCancel}
        onOk={onMenuOk}
        unmountOnExit
        style={{ width: 500 }}
        confirmLoading={loading}
      >
        <Form form={menuForm}>
          <FormItem field="menuIds">
            <div>
              <div style={{ marginBottom: 12 }}>
                <Button 
                  type="outline" 
                  size="small"
                  onClick={handleSelectAll}
                >
                  {isAllSelected ? '全取消' : '全选'}
                </Button>
              </div>
              <Tree
                checkable
                checkedKeys={checkedMenuKeys}
                onCheck={(checkedKeys, extra) => {
                  // Arco Design Tree 的 onCheck 回调参数可能是数组或对象
                  // 如果是数组，直接使用；如果是对象，取 checked 属性
                  const keys = Array.isArray(checkedKeys) ? checkedKeys : (checkedKeys?.checked || []);
                  console.log('keys====', keys);
                  // 更新 state
                  setCheckedMenuKeys(keys);
                  // 转换为数字数组存储到表单中
                  const checkedIds = keys.map(Number);
                  menuForm.setFieldValue('menuIds', checkedIds);
                }}
                treeData={menuTree.map(node => ({
                  key: String(node.id),
                  title: node.title,
                  children: node.children?.map(child => ({
                    key: String(child.id),
                    title: child.title
                  }))
                }))}
              />
            </div>
          </FormItem>
        </Form>
      </Modal>

      <Modal
        title="分配资源"
        visible={resourceModalVisible}
        onCancel={resourceModalCancel}
        onOk={onResourceOk}
        unmountOnExit
        style={{ width: 600 }}
        confirmLoading={loading}
      >
        <Form form={resourceForm}>
          <FormItem field="resourceIds" shouldUpdate>
            {(values) => {
              const resourceIds = values?.resourceIds || [];
              return (
                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                  {resourceCategories.map(category => {
                    const categoryResources = resourcesByCategory[category.id] || [];
                    const categoryResourceIds = categoryResources.map(r => r.id);
                    const checkedCategoryIds = resourceIds.filter((id: number) => 
                      categoryResourceIds.includes(id)
                    );
                    const isAllChecked = categoryResources.length > 0 && 
                      categoryResources.every(r => resourceIds.includes(r.id));
                    const isIndeterminate = checkedCategoryIds.length > 0 && !isAllChecked;

                    return (
                      <div key={category.id} style={{ marginBottom: '16px' }}>
                        <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                          <Checkbox
                            checked={isAllChecked}
                            indeterminate={isIndeterminate}
                            onChange={(checked) => {
                              const currentIds = resourceIds || [];
                              let newIds: number[];
                              if (checked) {
                                newIds = [...new Set([...currentIds, ...categoryResourceIds])];
                              } else {
                                newIds = currentIds.filter((id: number) => !categoryResourceIds.includes(id));
                              }
                              resourceForm.setFieldValue('resourceIds', newIds);
                            }}
                          >
                            {category.name}
                          </Checkbox>
                        </div>
                        <div style={{ paddingLeft: '24px' }}>
                          <CheckboxGroup
                            value={checkedCategoryIds}
                            onChange={(values) => {
                              const currentIds = resourceIds || [];
                              const otherIds = currentIds.filter((id: number) => !categoryResourceIds.includes(id));
                              resourceForm.setFieldValue('resourceIds', [...otherIds, ...values]);
                            }}
                          >
                            {categoryResources.map(resource => (
                              <Checkbox key={resource.id} value={resource.id}>
                                {resource.name}
                              </Checkbox>
                            ))}
                          </CheckboxGroup>
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            }}
          </FormItem>
        </Form>
      </Modal>
    </div>
  );
}

export default RoleManagement;

